// import * as React from "react";
// import { Provider, Flex, Header, Input } from "@fluentui/react-northstar";
import { useState, useEffect, useRef } from "react";
// import { useTeams } from "msteams-react-base-component";
import * as microsoftTeams from "@microsoft/teams-js";
import { useData, useTeamsUserCredential } from "@microsoft/teamsfx-react";

import { FluentProvider, Input, teamsDarkTheme, teamsHighContrastTheme, teamsLightTheme, Title1, tokens } from "@fluentui/react-components";
import config from "../lib/config";
import { TeamsFxContext } from "../Context";

/**
 * Implementation of FeedbackApp configuration page
 */
export default function FeedbackAppTabConfig() {

    const appInfo = useData(async ()=>
        {
            microsoftTeams.app.initialize();
            return microsoftTeams.app.getContext();
        }).data;

    const { theme, themeString, teamsUserCredential } = useTeamsUserCredential({
        initiateLoginEndpoint: config.initiateLoginEndpoint!,
        clientId: config.clientId!,
        });
    
    // const [{ inTeams, theme, context }] = useTeams({});
    const [text, setText] = useState<string>();
    const entityId = useRef("");

    // const onSaveHandler = (saveEvent: microsoftTeams.settings.SaveEvent) => {
    //     const host = "https://" + window.location.host;
    //     microsoftTeams.settings.setSettings({
    //         contentUrl: host + "/feedbackAppTab/?name={loginHint}&tenant={tid}&group={groupId}&theme={theme}",
    //         websiteUrl: host + "/feedbackAppTab/?name={loginHint}&tenant={tid}&group={groupId}&theme={theme}",
    //         suggestedDisplayName: "FeedbackApp",
    //         removeUrl: host + "/feedbackAppTab/remove.html?theme={theme}",
    //         entityId: entityId.current
    //     });
    //     saveEvent.notifySuccess();
    // };

    useEffect(() => {
        if (appInfo != undefined) {
            setText(appInfo.page.id);
            console.log(appInfo.page.id);
            entityId.current = appInfo.page.id;
            microsoftTeams.app.initialize().then(() => {
                console.log("Teams SDK Initialized");
          
                microsoftTeams.pages.config.registerOnSaveHandler((saveEvent) => {
                  const host = "https://" + window.location.host;
                  microsoftTeams.pages.config.setConfig({
                    entityId: entityId.current,
                    contentUrl: host + "/feedbackAppTab/?name={loginHint}&tenant={tid}&group={groupId}&theme={theme}",
                    websiteUrl: host + "/feedbackAppTab/?name={loginHint}&tenant={tid}&group={groupId}&theme={theme}",
                    removeUrl: host + "/feedbackAppTab/remove.html?theme={theme}",
                    suggestedDisplayName: "FeedbackApp",
                  });
          
                  saveEvent.notifySuccess(); // Must call this to complete the save process
                });
          
                // Set the tab as valid (so the Save button is enabled)
                microsoftTeams.pages.config.setValidityState(true);
              });
        }
    }, [appInfo]);

    return (
        <TeamsFxContext.Provider value={{ theme, themeString, teamsUserCredential }}>
              <FluentProvider
                theme={
                  themeString === "dark"
                    ? teamsDarkTheme
                    : themeString === "contrast"
                    ? teamsHighContrastTheme
                    : {
                        ...teamsLightTheme,
                        colorNeutralBackground1: "#f5f5f5",
                      }
                }
                style={{ background: tokens.colorNeutralBackground3 }}
              >
                    <div className="removeTab">
                        <Title1 style={{fontSize: '14px', display: 'grid', alignItems: 'center', textAlign: 'center'}}>Configure your tab</Title1>
                        <Input
                            placeholder="Enter a value here"
                            style={{width:"60%"}}
                            value={text}
                            onChange={(e, data) => {
                                if (e && data) {
                                    setText(data.value);
                                    entityId.current = data.value;
                                }
                            }}
                            required />
                    </div>
               </FluentProvider>
        </TeamsFxContext.Provider>
    );
};
